import { z } from 'zod';

import {
  BackgroundShade,
  LogoMinWidth,
} from '@digital-platform/rs-shared/domain';
import { BasePType } from './base';

export const LogoImage = BasePType.extend({
  type: z.enum(['logoImage']),
  width: z.optional(LogoMinWidth),
  bgShade: BackgroundShade,
});

export type LogoImage = z.infer<typeof LogoImage>;
